/* Shared, accessible pre-cart requirements. Prices are calculated by each builder. */
(() => {
  if (window.StepUpValidation) return;
  window.StepUpValidation = {
    create(root, button) {
      const panel = root.querySelector('[data-su-validation]');
      const list = panel.querySelector('[data-su-validation-list]');
      const runtime = panel.querySelector('[data-su-validation-runtime]');
      const announcement = root.querySelector('[data-su-validation-announcement]');
      const heading = panel.querySelector('[data-su-validation-heading]');
      const intro = panel.querySelector('[data-su-validation-intro]');
      const copy = JSON.parse(panel.querySelector('[data-su-validation-text]').textContent);
      const marked = new Map();
      let serial = 0;
      let signature = '';
      const identify = field => {
        if (!field.id) field.id = panel.id + '-field-' + (++serial);
        return field.id;
      };
      const reveal = field => {
        for (let parent = field.parentElement; parent && parent !== root; parent = parent.parentElement) {
          if (parent.tagName === 'DETAILS') parent.open = true;
        }
        field.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        field.focus({preventScroll:true});
      };
      const linkTo = (field, text) => {
        const link = document.createElement('a');
        link.href = '#' + identify(field);
        link.textContent = text;
        link.addEventListener('click', event => {event.preventDefault();reveal(field);});
        return link;
      };
      const clearMarkers = () => {
        marked.forEach((saved, field) => {
          if (saved.invalid === null) field.removeAttribute('aria-invalid');
          else field.setAttribute('aria-invalid',saved.invalid);
          if (saved.described === null) field.removeAttribute('aria-describedby');
          else field.setAttribute('aria-describedby',saved.described);
          field.classList.remove('su-field-invalid');
          saved.note.remove();
        });
        marked.clear();
      };
      const render = (issues, runtimeError = '') => {
        const next = JSON.stringify([issues.map(issue => [issue.key,issue.message,(issue.fields || []).map(identify),issue.action?.href]),runtimeError]);
        if (signature === next) return;
        signature = next;
        clearMarkers();list.replaceChildren();
        issues.forEach(issue => {
          const item = document.createElement('li');
          item.dataset.suIssue = issue.key;
          const fields = (issue.fields || []).filter(Boolean);
          if (fields.length) item.append(linkTo(fields[0],issue.message));
          else item.textContent = issue.message;
          if (issue.action) {
            const action = issue.action.field ? linkTo(issue.action.field,issue.action.label) : document.createElement('a');
            if (!issue.action.field) {action.href = issue.action.href;action.textContent = issue.action.label;}
            action.classList.add('su-validation-action');item.append(action);
          }
          list.append(item);
          fields.forEach(field => {
            if (issue.mark === false) return;
            let saved = marked.get(field);
            if (!saved) {
              const note = document.createElement('p');note.className = 'su-field-error';
              note.id = identify(field) + '-validation';
              saved = {note,invalid:field.getAttribute('aria-invalid'),described:field.getAttribute('aria-describedby')};
              marked.set(field,saved);
              field.insertAdjacentElement('afterend',note);
              field.classList.add('su-field-invalid');field.setAttribute('aria-invalid','true');
              field.setAttribute('aria-describedby',[saved.described,note.id].filter(Boolean).join(' '));
            }
            saved.note.textContent += (saved.note.textContent ? ' ' : '') + issue.message;
          });
        });
        panel.hidden = !issues.length && !runtimeError;
        list.hidden = !issues.length;intro.hidden = !issues.length;
        runtime.hidden = !runtimeError;runtime.textContent = runtimeError ? copy.runtime_prefix + ' ' + runtimeError : '';
        heading.textContent = issues.length ? copy.heading : copy.runtime_heading;
        button.setAttribute('aria-describedby',panel.hidden ? '' : panel.id);
        // Only announce a changed set of requirements, never every unchanged keystroke.
        const spoken = panel.hidden ? '' : heading.textContent + '. ' + issues.map(issue=>issue.message).join(' ') + (runtimeError ? ' ' + runtime.textContent : '');
        if (announcement.textContent !== spoken) announcement.textContent = spoken;
      };
      const resetClone = clone => {
        clone.querySelectorAll('.su-field-error').forEach(note=>note.remove());
        clone.querySelectorAll('.su-field-invalid').forEach(field=>{
          const original = [...marked.keys()].find(source=>source.id === field.id);
          const saved = marked.get(original);
          field.classList.remove('su-field-invalid');
          if (saved?.invalid) field.setAttribute('aria-invalid',saved.invalid);
          else field.removeAttribute('aria-invalid');
          if (saved?.described) field.setAttribute('aria-describedby',saved.described);
          else field.removeAttribute('aria-describedby');
        });
      };
      return {render,copy,resetClone,focus:() => panel.focus()};
    }
  };
  document.dispatchEvent(new Event('stepup:validation-ready'));
})();
